import {CommonMessages} from '../common.messages';

export const PanelClientUsersEditMessages = {
    GetClientUserFailed: {
        key: 'GetClientUserFailed',
        message: 'Error while communication with the server. Request for getting client user details failed.'
    },
    GetClientUserNoData: {
        key: 'GetClientUserNoData',
        message: 'Information about client user is not available.'
    },
    GetPermissionsFailed: {
        key: 'GetPermissionsFailed',
        message: 'Error while communication with the server. Request for getting permissions failed.'
    },
    GetClientUserAccountsRightsFailed: {
        key: 'GetClientUserAccountsRightsFailed',
        message: 'Error while communication with the server. Unable to get assigned account access rights to client user.'
    },
    GetPermissionsNoData: {
        key: 'GetPermissionsNoData',
        message: 'Can\'t find application permissions.'
    },
    GetClientFailed: {
        key: 'GetClientFailed',
        message: 'Error while communication with the server. Request for getting client failed.'
    },
    GetClientNoData: {
        key: 'GetClientNoData',
        message: 'Information about client is not available.'
    },
    GetCountriesFailed: {
        key: 'GetCountriesFailed',
        message: 'Unable to get available countries.'
    },
    GetCountriesInvalidData: {
        key: 'GetCountriesInvalidData',
        message: 'Countries data is corrupted.'
    },
    NoAccountsForSetup: {
        key: 'NoAccountsForSetup',
        message: 'Client user already has assigned rights to all accounts or has not accounts for setup.'
    },
    GetClientAccountsFailed: {
        key: 'GetClientAccountsFailed',
        message: 'Error while communication with the server. Unable to get client accounts.'
    },
    GetClientAccountsNoData: {
        key: 'GetClientAccountsNoData',
        message: 'Can\'t find client accounts.'
    },
    GetClientUserStatusTriggersFailed: {
        key: 'GetClientUserStatusTriggersFailed',
        message: 'Error while communication with the server. Unable to get available client user status transitions.'
    },
    UpdateClientStatusFailed: {
        key: 'UpdateClientStatusFailed',
        message: 'Error while request to the server. Unable to update client user status.'
    },
    UpdateClientUserStatusSucceed: {
        key: 'UpdateClientUserStatusSucceed',
        message: 'Client user status is successfully updated.'
    },
    UpdateClientUserStatusToDeactivatedRestricted: {
        key: 'UpdateClientUserStatusToDeactivatedRestricted',
        message: 'Additional permissions are required for client user deactivation.'
    },
    UpdateClientUserDetailsFailed: {
        key: 'UpdateClientUserDetailsFailed',
        message: 'Error while request to the server. Unable to update client user details.'
    },
    UpdateClientUserPhoneFailed: {
        key: 'UpdateClientUserPhoneFailed',
        message: 'Error while request to the server. Unable to update client user phone number.'
    },
    GetClientUsersFailed: {
        key: 'GetClientUsersFailed',
        message: 'Error while communication with the server. Unable to get all client users.'
    },
    GetClientUsersNotFound: {
        key: 'GetClientUsersNotFound',
        message: 'Error while communication with the server. Unable to find other client users.'
    },
    ClientHasOnlyOneClientUser: {
        key: 'ClientHasOnlyOneClientUser',
        message: 'The client hasn\'t other client users.'
    },
    GetSupervisedUsersFailed: {
        key: 'GetSupervisedUsersFailed',
        message: 'Error while communication with the server. Unable to get client user supervised rights.'
    },
    NoOtherClientUsersForSupervising: {
        key: 'NoOtherClientUsersForSupervising',
        message: 'Client user already has assigned supervised rights to all other users.'
    },
    SendUserResetPasswordFailed: {
        key: 'SendUserResetPasswordFailed',
        message: 'Unable to send <<email>> email to the user.'
    },
    SendUserResetPasswordSucceed: {
        key: 'SendUserResetPasswordSucceed',
        message: 'The email for <<email>> is sent successfully.'
    },
    ...CommonMessages
};
